const MOBILE_PATTERN = /^09\d{9}$/;

export const normalizeMobile = (value) => (value || "").replace(/\D/g, "");

export const validatePartnerForm = (form, { isEdit = false } = {}) => {
  const errors = {};
  const level = form.partnerLevel;
  const type = form.partnerType;

  if (!isEdit) {
    const mobile = normalizeMobile(form.mobile);
    if (!mobile) {
      errors.mobile = "شماره موبایل الزامی است.";
    } else if (!MOBILE_PATTERN.test(mobile)) {
      errors.mobile = "شماره موبایل باید ۱۱ رقم و با 09 شروع شود.";
    }
  }

  if (!form.commissionGroupId) {
    errors.commissionGroupId = "گروه پورسانتی الزامی است.";
  }
  if (!level) errors.partnerLevel = "سطح نماینده الزامی است.";
  if (!type) errors.partnerType = "نوع نماینده الزامی است.";
  if (!form.status) errors.status = "وضعیت الزامی است.";

  if (level === "Level2" && !form.parentPartnerId) {
    errors.parentPartnerId = "کارشناس فروش باید والد سطح ۱ داشته باشد.";
  }

  const referralError = validateReferralCode(form.referralCode);
  if (referralError) {
    errors.referralCode = referralError;
  }

  return errors;
};

export const normalizeCanCreateSubPartners = (form) => {
  if (form.partnerLevel === "Level2") return false;
  if (form.partnerType === "PublicReferrer") return false;
  return Boolean(form.canCreateSubPartners);
};

const REFERRAL_CODE_PATTERN = /^[A-Za-z0-9_-]{3,32}$/;

export const normalizeReferralCodeInput = (value) => {
  const trimmed = (value || "").trim();
  if (!trimmed) return "";
  return trimmed.replace(/[a-zA-Z]/g, (character) => character.toUpperCase());
};

export const validateReferralCode = (value) => {
  if (!value?.trim()) return null;

  const normalized = normalizeReferralCodeInput(value);
  if (normalized.length < 3 || normalized.length > 32) {
    return "کد معرف باید بین ۳ تا ۳۲ کاراکتر باشد.";
  }
  if (!REFERRAL_CODE_PATTERN.test(normalized)) {
    return "کد معرف فقط می‌تواند شامل حروف انگلیسی، اعداد، خط تیره و زیرخط باشد.";
  }
  return null;
};

export const validateTeamShareForm = (form, childPartner) => {
  const errors = {};
  const share = Number(form.sharePercentOfParentCommission);

  if (!form.parentPartnerId) errors.parentPartnerId = "نماینده والد الزامی است.";
  if (!form.childPartnerId) errors.childPartnerId = "نماینده زیرمجموعه الزامی است.";

  if (!share || share <= 0 || share > 100) {
    errors.sharePercentOfParentCommission = "سهم باید بزرگ‌تر از ۰ و حداکثر ۱۰۰ باشد.";
  }

  if (!form.effectiveFrom) {
    errors.effectiveFrom = "تاریخ شروع اعتبار الزامی است.";
  }

  if (
    childPartner &&
    childPartner.parentPartnerId &&
    Number(childPartner.parentPartnerId) !== Number(form.parentPartnerId)
  ) {
    errors.childPartnerId = "این نماینده متعلق به والد انتخاب‌شده نیست.";
  }

  return errors;
};
